import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.svg";


const Header = ({ openModal, setHeaderHeight }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const headerRef = useRef(null);

  useEffect(() => {
    if (headerRef.current) {
      setHeaderHeight(headerRef.current.offsetHeight);
    }
  }, [setHeaderHeight]);

  return (
    <header className="sticky top-0 py-3 md:py-6 bg-background border-b border-border z-50" ref={headerRef}>
      <div className="w-full flex flex-row justify-center items-center relative lg:flex-col lg:static">
        <div className="flex flex-col items-center mb-0 lg:mb-4">
          <Link to="/" className="flex flex-col items-center no-underline">
            <img src={logo} alt="Mackintosh Kilts Logo" className="h-[60px] lg:h-[88px]" />

          </Link>
        </div>
        <button className="block lg:hidden absolute left-4 text-text" onClick={toggleMenu}>
          {isMenuOpen ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="3" y1="12" x2="21" y2="12"></line>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
          )}
        </button>
        <nav className={`${isMenuOpen ? "flex" : "hidden"} lg:flex absolute top-full left-0 w-full bg-background flex-col items-center py-8 border-b border-border lg:static lg:w-auto lg:bg-transparent lg:flex-row lg:py-0 lg:border-none`}>
          <Link to="/" onClick={() => setIsMenuOpen(false)} className="font-sans text-text text-sm font-normal tracking-[1.2px] uppercase relative transition-colors duration-300 hover:text-primary my-4 py-0 px-0 border-none lg:my-0 lg:py-1 lg:px-6 lg:border-r lg:border-border lg:last:border-r-0 after:content-[''] after:absolute after:bottom-[-2px] after:left-0 after:w-full after:h-[1px] after:bg-primary after:scale-x-0 after:origin-left after:transition-transform after:duration-500 hover:after:scale-x-100">
            Home
          </Link>
          <Link to="/our-story" onClick={() => setIsMenuOpen(false)} className="font-sans text-text text-sm font-normal tracking-[1.2px] uppercase relative transition-colors duration-300 hover:text-primary my-4 py-0 px-0 border-none lg:my-0 lg:py-1 lg:px-6 lg:border-r lg:border-border lg:last:border-r-0 after:content-[''] after:absolute after:bottom-[-2px] after:left-0 after:w-full after:h-[1px] after:bg-primary after:scale-x-0 after:origin-left after:transition-transform after:duration-500 hover:after:scale-x-100">
            Our Story
          </Link>
          <Link to="/craftsmanship" onClick={() => setIsMenuOpen(false)} className="font-sans text-text text-sm font-normal tracking-[1.2px] uppercase relative transition-colors duration-300 hover:text-primary my-4 py-0 px-0 border-none lg:my-0 lg:py-1 lg:px-6 lg:border-r lg:border-border lg:last:border-r-0 after:content-[''] after:absolute after:bottom-[-2px] after:left-0 after:w-full after:h-[1px] after:bg-primary after:scale-x-0 after:origin-left after:transition-transform after:duration-500 hover:after:scale-x-100">
            Craftsmanship
          </Link>
          <Link to="/gallery" onClick={() => setIsMenuOpen(false)} className="font-sans text-text text-sm font-normal tracking-[1.2px] uppercase relative transition-colors duration-300 hover:text-primary my-4 py-0 px-0 border-none lg:my-0 lg:py-1 lg:px-6 lg:border-r lg:border-border lg:last:border-r-0 after:content-[''] after:absolute after:bottom-[-2px] after:left-0 after:w-full after:h-[1px] after:bg-primary after:scale-x-0 after:origin-left after:transition-transform after:duration-500 hover:after:scale-x-100">
            Gallery
          </Link>
          <a
            href="https://www.christiescashmere.co.uk/collections/highlander-wear"
            className="font-sans text-text text-sm font-normal tracking-[1.2px] uppercase relative transition-colors duration-300 hover:text-primary my-4 py-0 px-0 border-none lg:my-0 lg:py-1 lg:px-6 lg:border-r lg:border-border lg:last:border-r-0 after:content-[''] after:absolute after:bottom-[-2px] after:left-0 after:w-full after:h-[1px] after:bg-primary after:scale-x-0 after:origin-left after:transition-transform after:duration-500 hover:after:scale-x-100 flex items-center"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setIsMenuOpen(false)}
          >
            Shop
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="ml-1"
            >
              <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
              <polyline points="15 3 21 3 21 9"></polyline>
              <line x1="10" y1="14" x2="21" y2="3"></line>
            </svg>
          </a>
          <Link to="/contact" onClick={() => setIsMenuOpen(false)} className="font-sans text-text text-sm font-normal tracking-[1.2px] uppercase relative transition-colors duration-300 hover:text-primary my-4 py-0 px-0 border-none lg:my-0 lg:py-1 lg:px-6 lg:border-r lg:border-border lg:last:border-r-0 after:content-[''] after:absolute after:bottom-[-2px] after:left-0 after:w-full after:h-[1px] after:bg-primary after:scale-x-0 after:origin-left after:transition-transform after:duration-500 hover:after:scale-x-100">
            Contact
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
